import { Link } from 'react-router-dom'

import BlogHeader from '../components/BlogHeader'
import PostItem from '../components/PostItem'
import { getPosts } from '../scripts/utils'
import { Seo } from '../seo/Seo'

const Home = () => {
  const posts = getPosts()
  const heroSubtitle = 'Cloud architecture, serverless, migrations and scalable backends - expert help for small teams.'
  return (
    <>
      <Seo />

      <section className='py-12'>
        <div className='max-w-4xl mx-auto text-center'>
          <h1 className='text-4xl md:text-5xl font-bold text-white'>CloudSoft - Independent Cloud Consulting</h1>
          <p className='mt-4 text-lg text-gray-300'>{heroSubtitle}</p>
          <div className='mt-8 flex items-center justify-center gap-4'>
            <Link to='/services' className='bg-blue-600 hover:bg-blue-500 text-white px-5 py-3 rounded-md'>
              Services
            </Link>
            <Link
              to='/portfolio'
              className='border border-gray-700 text-gray-200 px-5 py-3 rounded-md hover:border-gray-500'
            >
              Portfolio
            </Link>
          </div>
        </div>
      </section>

      <section className='py-8'>
        <div className='max-w-6xl mx-auto px-4'>
          <div className='grid lg:grid-cols-3 gap-6'>
            <div className='p-6 bg-gray-800 rounded-md'>
              <h3 className='text-xl font-semibold text-white'>What I do</h3>
              <ul className='mt-3 text-gray-300 list-disc ml-5'>
                <li>Cloud architecture & migrations (AWS)</li>
                <li>Serverless & Lambdas, CDK infrastructure as code</li>
                <li>Backend services with Node.js / TypeScript</li>
              </ul>
            </div>
            <div className='p-6 bg-gray-800 rounded-md'>
              <h3 className='text-xl font-semibold text-white'>Typical engagements</h3>
              <ul className='mt-3 text-gray-300 list-disc ml-5'>
                <li>Architecture reviews & cost-optimisation</li>
                <li>Proofs-of-concept and short-term delivery sprints</li>
                <li>Team mentoring and knowledge transfer</li>
              </ul>
            </div>
            <div className='p-6 bg-gray-800 rounded-md'>
              <h3 className='text-xl font-semibold text-white'>Contact</h3>
              <p className='mt-3 text-gray-300'>
                Available for short consultancy and longer contracts. Email:{' '}
                <a className='text-blue-400' href='mailto:contact@cloudsoft.com.pl'>
                  contact@cloudsoft.com.pl
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className='py-8'>
        <div className='max-w-6xl mx-auto px-4'>
          <BlogHeader title='Recent posts' description='Selected posts from the blog' />
          <div className='grid gap-8 lg:grid-cols-2'>
            {posts.slice(0, 4).map(post => (
              <PostItem key={post.slug} post={post} />
            ))}
          </div>
          <div className='mt-6 text-center'>
            <Link to='/posts' className='text-blue-400 hover:underline'>
              View all posts
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}

export default Home
